/* src/app/modules/shared/components/column/column-flavor/column-flavor.component.scss */
app-column-flavor {
  display: contents;
}
/*# sourceMappingURL=column-flavor.component.css.map */
